import { render, staticRenderFns } from "./CategoriaContasPadrao.vue?vue&type=template&id=28f4af2a&scoped=true&"
import script from "./CategoriaContasPadrao.vue?vue&type=script&setup=true&lang=js&"
export * from "./CategoriaContasPadrao.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4af2a",
  null
  
)

export default component.exports